export const CREATE_SPOT_REQUEST = 'CREATE_SPOT_REQUEST';

export const createSpotRequest = ( spotData: Record<string, any> ) => ({
    type: CREATE_SPOT_REQUEST,
    payload: { spotData },
});
